"use client";

import dynamic from "next/dynamic";
import { useState } from "react";

// Loaded on the first press of Help: the sheet carries the voice input and
// upload code, which no page needs until someone asks for help.
const SupportSheet = dynamic(() => import("@/components/support/SupportSheet"), {
  ssr: false,
});

/**
 * The Help sheet for the side nav: one open state shared by its two openers
 * (the strip's Help button and the phone header's), and the sheet itself,
 * mounted from the first press on so it can animate closed.
 *
 * @param {boolean} enabled  Signed in; signed-out pages have no Help
 * @returns {{ help: { open: boolean, onClick: () => void } | null, sheet: import("react").ReactNode }}
 */
export function useHelpSheet(enabled) {
  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  if (!enabled) return { help: null, sheet: null };

  const toggle = () => {
    setLoaded(true);
    setOpen((wasOpen) => !wasOpen);
  };
  return {
    help: { open, onClick: toggle },
    sheet: loaded && <SupportSheet open={open} onOpenChange={setOpen} />,
  };
}
